/**
 * Shape and hydration of the listing form state.
 *
 * `initialForm` and the listing -> form mapping are 1:1 moves out of
 * AdminListingsPage.js (L1 extraction). Every field keeps its exact
 * coercion, including the ones the discovery flagged: numbers become
 * strings, `sort_order` falls back to "0" while the other numerics fall
 * back to "", and the three booleans are coerced with `!!`.
 */

export const initialForm = {
  unit_id: "",
  city_id: "",
  room_id: "",
  slug: "",
  title_de: "",
  title_en: "",
  description_de: "",
  description_en: "",
  price_chf_month: "",
  bedrooms: "",
  bathrooms: "",
  size_sqm: "",
  latitude: "",
  longitude: "",
  address: "",
  location_description: "",
  show_address: false,
  available_from: "",
  is_published: false,
  sort_order: "0",
  // Listing schema v2 (Migration 118): optional presentation fields.
  all_inclusive: false,
  wg_size: "",
  floor: "",
  district_de: "",
  district_en: "",
  min_stay_months: "",
  lease_type: "",
  flatmates_description_de: "",
  flatmates_description_en: "",
};

/**
 * Builds the form state for an existing listing row. Mirrors the object
 * literal that handleEditClick used to inline.
 */
export function formFromListing(listing) {
  return {
  unit_id: listing.unit_id || "",
  city_id: listing.city_id || "",
  room_id: listing.room_id || "",
  slug: listing.slug || "",
  title_de: listing.title_de || "",
  title_en: listing.title_en || "",
  description_de: listing.description_de || "",
  description_en: listing.description_en || "",
  price_chf_month: listing.price_chf_month != null ? String(listing.price_chf_month) : "",
  bedrooms: listing.bedrooms != null ? String(listing.bedrooms) : "",
  bathrooms: listing.bathrooms != null ? String(listing.bathrooms) : "",
  size_sqm: listing.size_sqm != null ? String(listing.size_sqm) : "",
  latitude: listing.latitude != null ? String(listing.latitude) : "",
  longitude: listing.longitude != null ? String(listing.longitude) : "",
  address: listing.address || "",
  location_description: listing.location_description || "",
  show_address: !!listing.show_address,
  available_from: listing.available_from || "",
  is_published: !!listing.is_published,
  sort_order: listing.sort_order != null ? String(listing.sort_order) : "0",
  all_inclusive: !!listing.all_inclusive,
  wg_size: listing.wg_size != null ? String(listing.wg_size) : "",
  floor: listing.floor || "",
  district_de: listing.district_de || "",
  district_en: listing.district_en || "",
  min_stay_months: listing.min_stay_months != null ? String(listing.min_stay_months) : "",
  lease_type: listing.lease_type || "",
  flatmates_description_de: listing.flatmates_description_de || "",
  flatmates_description_en: listing.flatmates_description_en || "",
  };
}

/**
 * The two comma-separated amenity inputs, derived from the structured
 * server objects exactly as handleEditClick did.
 */
export function amenitiesToInputStrings(amenities) {
  const ams = Array.isArray(amenities) ? amenities : [];
  return {
    de: ams.map((a) => a.label_de || "").filter(Boolean).join(", "),
    en: ams.map((a) => a.label_en || "").filter(Boolean).join(", "),
  };
}
